/**
 * QL-359 — a tenant's public API allowance: requests per fixed window, all of the
 * tenant's API keys and endpoints combined. Quantfolio sets or clears the
 * override; partners only see it. The window itself is not configurable.
 */

/**
 * Upper bound on an override. Far above any real integration's need; it keeps a
 * typo from switching the limit off in practice and the value inside a
 * Postgres `integer`. The API enforces it; the tenant card mirrors it.
 */
export const MAX_TENANT_API_RATE_LIMIT = 1_000_000;

/** The allowance as shown on the tenant detail (GET /internal/admin/tenants/:id). */
export type TenantApiRateLimit = {
  /** The allowance in force: `override` when set, otherwise `defaultLimit`. */
  limit: number;
  /** The tenant's own allowance; `null` inherits the environment default. */
  override: number | null;
  /** The environment default every tenant without an override gets. */
  defaultLimit: number;
  /** The fixed counting window, in seconds (60). */
  windowSeconds: number;
};

/** PUT /internal/admin/tenants/:id/api-rate-limit — `null` clears the override. */
export type UpdateTenantApiRateLimitRequest = {
  limit: number | null;
};
